<template>
	<entity-select-view class="task-select-view" url="/tasks/search/" :value="value" @input="$emit('input', $event)" :map="contactMap" :labelMap="contactLabel" :validator="contactValidator" :clearMap="clearContact" v-bind="$attrs" @select="function (obj) { $emit('select', obj); }" />
</template>

<script>
	import EntitySelectView from './EntitySelectView'

	export default {
		components: {
			'EntitySelectView': EntitySelectView
		},
		props: {
			value: {
				type: Object,
				default() {
					return {};
				}
			},
			altName: {
				type: String,
				default: 'task'
			}
		},
		methods: {
			contactMap(obj) {
				var map = {
					_embedded: {}
				};

				map._embedded[this.altName] = obj;
				map[this.altName + '_id'] = obj.id

				return map;
			},
			contactLabel(obj) {
				obj = obj._embedded[this.altName];

				console.log(obj, obj.name);

				return '#' + obj.num + ', ' + obj.name;
			},
			contactValidator(obj) {
				console.log('validator', obj);

				return obj[this.altName + '_id'] !== null;
			},
			clearContact(obj) {
				var blank = {};

				blank[this.altName + '_id'] = null;

				return blank;
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>